import {
  InsightsHero,
  BlogSection,
  NewsSection,
  EventsSection,
  ScrollReveal,
} from "../components";
import { Outlet, useLocation } from "react-router-dom";

export default function InsightsPage() {
  const location = useLocation();
  const isBlogs = location.pathname.includes("/blog/");
  const isNews = location.pathname.includes("/news/");
  const isEvents = location.pathname.includes("/events/");

  if (isBlogs || isNews || isEvents) {
    return <Outlet />;
  }
  return (
    <div>
      <ScrollReveal><InsightsHero /></ScrollReveal>
      <ScrollReveal><BlogSection /></ScrollReveal>
      <ScrollReveal><NewsSection /></ScrollReveal>
      <ScrollReveal><EventsSection /></ScrollReveal>
    </div>
  );
}
